import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({ icon = 'ri-inbox-2-line', title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 rounded-lg bg-background-50 border border-background-200">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-4">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="text-base md:text-lg font-semibold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}